import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { config, queryClient, bet4peerTheme, RainbowKitProvider, WagmiProvider, QueryClientProvider } from "./lib/wagmi";
import { Web3Provider } from "./context/Web3Context";
import { WebSocketProvider } from "./context/WebSocketContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { LiveFeed } from "./components/layout/LiveFeed";
import { HomePage } from "./pages/HomePage";
import { BetsPage } from "./pages/BetsPage";
import { CreateBetPage } from "./pages/CreateBetPage";
import { BetDetailPage } from "./pages/BetDetailPage";
import { DashboardPage } from "./pages/DashboardPage";
import { HistoryPage } from "./pages/HistoryPage";
import { TreasuryPage } from "./pages/TreasuryPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { OraclePage } from "./pages/OraclePage";
import { GamificationLeaderboardPage } from "./pages/GamificationLeaderboardPage";
import { ProfilePage } from "./pages/ProfilePage";
import { TournamentPage } from "./pages/TournamentPage";
import { AdminPage } from "./pages/AdminPage";
import AdminPricingPage from "./pages/AdminPricingPage";
import BoosterPacksPage from "./pages/BoosterPacksPage";
import { TeamsPage } from "./pages/TeamsPage";
import { SeasonsPage } from "./pages/SeasonsPage";
import { SeasonDetailPage } from "./pages/SeasonDetailPage";
import { TournamentAnalyticsPage } from "./pages/TournamentAnalyticsPage";
import { TeamChatPage } from "./pages/TeamChatPage";
import NetworkSwitchModal from "./components/NetworkSwitchModal";
import { B4PPage } from "./pages/B4PPage";
import B4PLaunchPage from "./pages/B4PLaunchPage";
import TokenomicsPage from "./pages/TokenomicsPage";
import RoadmapPage from "./pages/RoadmapPage";
import FAQPage from "./pages/FAQPage";
import PresalePage from "./pages/PresalePage";
import AirdropPage from "./pages/AirdropPage";
import DexGuidePage from "./pages/DexGuidePage";
import LiquidityPage from "./pages/LiquidityPage";
import SponsorPage from "./pages/SponsorPage";
import JackpotPage from "./pages/JackpotPage";
import StakingPage from "./pages/StakingPage";
import AIBetMasterPage from "./pages/AIBetMasterPage";
import BurnPage from "./pages/BurnPage";
import SocialTradingPage from "./pages/SocialTradingPage";
import QuestsPage from "./pages/QuestsPage";
import SocialLeaderboardPage from "./pages/SocialLeaderboardPage";
import RefTracker from "./components/RefTracker";
import TierUpModal from "./components/TierUpModal";
import OnboardingModal from "./components/OnboardingModal";

function App() {
    return (
        <ThemeProvider>
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider theme={bet4peerTheme} modalSize="compact">
                    <Web3Provider>
                        <WebSocketProvider>
                            <BrowserRouter>
                                <div className="App min-h-screen flex flex-col">
                                    <RefTracker />
                                    <TierUpModal />
                                    <OnboardingModal />
                                    <NetworkSwitchModal />
                                    <Navbar />
                                    <LiveFeed />
                                    <main id="main-content" role="main" aria-label="Main content" className="flex-1">
                                        <Routes>
                                            <Route path="/" element={<HomePage />} />
                                            <Route path="/bets" element={<BetsPage />} />
                                            <Route path="/create" element={<CreateBetPage />} />
                                            <Route path="/bet/:id" element={<BetDetailPage />} />
                                            <Route path="/bets/:id" element={<BetDetailPage />} />
                                            <Route path="/dashboard" element={<DashboardPage />} />
                                            <Route path="/history" element={<HistoryPage />} />
                                            <Route path="/treasury" element={<TreasuryPage />} />
                                            <Route path="/leaderboard" element={<LeaderboardPage />} />
                                            <Route path="/leaderboard/xp" element={<GamificationLeaderboardPage />} />
                                            <Route path="/profile/:address" element={<ProfilePage />} />
                                            <Route path="/tournaments" element={<TournamentPage />} />
                                            <Route path="/oracle" element={<OraclePage />} />
                                            <Route path="/admin" element={<AdminPage />} />
                                            <Route path="/admin/pricing" element={<AdminPricingPage />} />
                                            <Route path="/booster-packs" element={<BoosterPacksPage />} />
                                            <Route path="/teams" element={<TeamsPage />} />
                                            <Route path="/teams/:teamId/chat" element={<TeamChatPage />} />
                                            <Route path="/b4p" element={<B4PPage />} />
                                            <Route path="/b4p-launch" element={<B4PLaunchPage />} />
                                            <Route path="/project" element={<B4PLaunchPage />} />
                                            <Route path="/tokenomics" element={<TokenomicsPage />} />
                                            <Route path="/roadmap" element={<RoadmapPage />} />
                                            <Route path="/faq" element={<FAQPage />} />
                                            <Route path="/presale" element={<PresalePage />} />
                                            <Route path="/airdrop" element={<AirdropPage />} />
                                            <Route path="/lockdrop" element={<AirdropPage />} />
                                            <Route path="/dex-guide" element={<DexGuidePage />} />
                                            <Route path="/liquidity" element={<LiquidityPage />} />
                                            <Route path="/sponsor" element={<SponsorPage />} />
                                            <Route path="/seasons" element={<SeasonsPage />} />
                                            <Route path="/seasons/:seasonId" element={<SeasonDetailPage />} />
                                            <Route path="/analytics" element={<TournamentAnalyticsPage />} />
                                            <Route path="/jackpot" element={<JackpotPage />} />
                                            <Route path="/staking" element={<StakingPage />} />
                                            <Route path="/ai-bets" element={<AIBetMasterPage />} />
                                            <Route path="/burn" element={<BurnPage />} />
                                            <Route path="/social-trading" element={<SocialTradingPage />} />
                                            <Route path="/quests" element={<QuestsPage />} />
                                            <Route path="/social-leaderboard" element={<SocialLeaderboardPage />} />
                                        </Routes>
                                    </main>
                                    <Footer />
                                    <div aria-live="polite" aria-atomic="true" className="aria-live-region" id="aria-announcements"></div>
                                </div>
                            </BrowserRouter>
                            <Toaster 
                                position="bottom-right"
                                toastOptions={{
                                    duration: 4000,
                                }}
                            />
                        </WebSocketProvider>
                    </Web3Provider>
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
        </ThemeProvider>
    );
}

export default App;
